import { InvoiceTypeEnum } from '@fora-monorepo/employer-my-pages-common/types';

import { TypedTFunction } from '../../i18n/i18n';

export const getTypeText = (status: InvoiceTypeEnum | null, t: TypedTFunction) => {
  switch (status) {
    case InvoiceTypeEnum.Invoice:
      return t('section.invoiceDetails.pdfFile');
    case InvoiceTypeEnum.Credit:
      return t('section.invoiceDetails.credit');
    case InvoiceTypeEnum.LatePaymentInterest:
      return t('section.invoiceDetails.latePaymentInterest');
    default:
      return '';
  }
};
